import React, { Fragment } from 'react'
import styled from 'styled-components'

const ProfileInfo = styled.article `
  background:#333;
  width:50%;
  min-height:300px;
  border-radius: 100% 0 0 0;

  .icon{
    width:200px;
    height:200px;
    border-radius:100%;
    background:tomato;
  }

`

const Profile = () => (
  <Fragment>
    <ProfileInfo>
       <div className="icon"></div>
    </ProfileInfo>
  </Fragment>
)

export default Profile


// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/About/components/profile.js